import { useDispatch, useSelector } from "react-redux";
import Helper from "../Helper";
import useStateRef from "react-usestateref";
import React, { useEffect } from "react";
import { APPLICATION_JSON } from "../../middleware/types";
import { organizationDetailsAction } from "../../middleware/organizationDetailsAction";

export const Organization = () => {
    const [orgranizationDetails, setOrganizationDetails, organizationDetailsRef] =  useStateRef('')
    const [billToDetails, setBillToDetails, billToDetailsRef] = useStateRef('')
    const [additionalinformation, setAdditionalInformation, additionalInformationRef] = useStateRef('')
    const userId = useSelector(state => state.getOrganizationDetails.userId);
    const [showOrganizationDetails, setShowOrganizationDetails, showOrganizationDetailsRef] = useStateRef(false);
    const [newOrganizationDetails, setNewOrganizationDetails, newOrganizationDetailsRef] = useStateRef('');
    const [currentOrgId, setCurrentOrgId, currentOrgIdRef] = useStateRef('');
    const [hasFormError, setHasFormError, hasFormErrorRef] = useStateRef(false);
    const dispatch = useDispatch();
    
    useEffect(() => {
        {userId &&  getOrganizationDetails(userId)}
        setShowOrganizationDetails(false);
        document.getElementById("jde_number").value = "";

    }, [userId])

    async function getOrganizationDetails(userId){
        var actionUrl = "api/rest/cb/profile/csr-organization";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}?userId=${userId}`
        var res = await Helper.fetchCallFunction(Url, "GET", false, "", '')

        if (res.response != null) {
            setOrganizationDetails(res.response);
            {res.response.billTo ? setBillToDetails(organizationDetailsRef.current.billTo): setBillToDetails('')}
            {res.response.additionalinformation	? setAdditionalInformation(res.response.additionalinformation) : setAdditionalInformation('')}
            document.getElementById("csr_head").scrollIntoView({behavior:'smooth'});
        } else {
            setIsLoading(false)
        }
    }

    async function getSearchOrganizationDetails(event){
        event.preventDefault();
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        setCurrentOrgId(formValue.jdeNumber);
        const inputMap = JSON.stringify(formValue);
        var actionUrl = "api/rest/cb/profile/get-organization-details";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`

        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)

        if (res.response != null) {
           setNewOrganizationDetails(res.response.orgSearchList);
           setShowOrganizationDetails(true);
           setHasFormError(false);
        } else {
            setShowOrganizationDetails(false);
            setHasFormError(true);
        }

        }

        async function addOrganizationToUser(event){
            event.preventDefault();
            // var inputMap = { orgId: currentOrgIdRef.current, userId: userId }
            var actionUrl = "api/rest/cb/profile/add-organization-to-user";
            var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var inputMap = {'testInput':'true'}
            inputMap = JSON.stringify(inputMap);
            var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
        if (res.response != null) {
                if(res.response.error ==='false'){
                    const showOrganizationHeader = false;
                    dispatch(organizationDetailsAction(showOrganizationHeader))
                }
            } else {
            }
        }

        function cancelJDESearch(event){
            event.preventDefault();
            document.getElementById("jde_number").value = "";
            document.getElementById("jde_number").classList.remove("form-error");
            setShowOrganizationDetails(false);
        }

        function cancelAddOrganizationToUser(event){
            event.preventDefault();
            const showOrganizationHeader = false;
            dispatch(organizationDetailsAction(showOrganizationHeader))
        }

    return(
        <div className='row align-items-start mt-3 '>
        <div className='col-12 col-md-7 mb-2 mb-md-0'>
            <div className='row'>
                <div className='col-12 col-md-10 col-two '>
                    <dl className='d-flex flex-wrap'>
                        <dt>Name:</dt>
                        <dd>{organizationDetailsRef.current && organizationDetailsRef.current.name}</dd>
                        <dt>Email:</dt>
                        <dd>{organizationDetailsRef.current && organizationDetailsRef.current.email}</dd>
                        <dt className='c-red'>NEW JDE Account#:</dt>
                        <dd className='mb-2'>
                            <form method='post' onSubmit={getSearchOrganizationDetails}>
                                <input name="jdeNumber" id='jde_number' className={hasFormErrorRef.current?'form-control mb-2 form-error':'form-control mb-2'} type='text' />
                                <input name="userId" type="hidden" value={userId}></input>
                                <input className='btn btn-primary mb-2 me-1' type='submit' value='Search' />
                                <input id="jdeCancel" className='btn btn-primary mb-2' onClick={cancelJDESearch} type='button' value='Cancel' />
                            </form>
                        </dd>
                        {organizationDetailsRef.current.custType === 'Temp B2I' && additionalInformationRef.current &&
                                <div className='additional-info'>
                                    <p className='additional-info-text'>
                                        Additional Information
                                    </p>
                                    <span className='org-text'>School/Organization Name: </span>
                                    <span className='org-value'>{additionalInformationRef.current.orgName && additionalInformationRef.current.orgName}</span><br/>
                                    <span className='org-text'>Street Address: </span>
                                    <span className='org-value'>{additionalInformationRef.current.streetAddress && additionalInformationRef.current.streetAddress}</span><br/>
                                    <span className='org-text'>City: </span>
                                    <span className='org-value'>{additionalInformationRef.current.city && additionalInformationRef.current.city}</span><br/>
                                    <span className='org-text'>State: </span>
                                    <span className='org-value'>{additionalInformationRef.current.state && additionalInformationRef.current.state}</span><br/>
                                    <span className='org-text'>Comments: </span>
                                    <span className='org-value'></span>
                                </div>
                            }
                    </dl>
                    <div id='admin-result' className='d-flex flex-wrap'>
                        <dl className='d-flex flex-wrap '>
                            
                                {billToDetailsRef.current && organizationDetailsRef.current.custType !=='International User' && !showOrganizationDetailsRef.current &&
                                    <>
                                        <dt>Bill To:</dt>
                                        <dd>{billToDetailsRef.current.companyName && billToDetailsRef.current.companyName}</dd>
                                        <dt></dt>
                                        <dd>{billToDetailsRef.current.address1 && billToDetailsRef.current.address1}</dd>
                                        <dt></dt>
                                        <dd>{billToDetailsRef.current.address2 && billToDetailsRef.current.address2}</dd>
                                        <dt></dt>
                                        <dd>{billToDetailsRef.current.city && billToDetailsRef.current.city} {billToDetailsRef.current.state && ' '+billToDetailsRef.current.state} {billToDetailsRef.current.zip && ' '+billToDetailsRef.current.zip}</dd>
                                    </>
                                }
                                 {!showOrganizationDetailsRef.current &&
                                 <>
                                    {organizationDetailsRef.current.custType && organizationDetailsRef.current.custType === 'International User' ? <div>International User</div>:
                                    <>    
                                        <dt>Cust Type:</dt>
                                        <dd>{organizationDetailsRef.current.custType && organizationDetailsRef.current.custType}</dd>
                                    </>
                                    }
                                </>
                                 }
                            
                            {showOrganizationDetailsRef.current && 
                                <>
                                    <dt className='c-red'>NEW Bill To:</dt>
                                    <dd className='c-red'>{newOrganizationDetailsRef.current.newBillTo.name && newOrganizationDetailsRef.current.newBillTo.name}</dd>
                                    <dt></dt>
                                    <dd className='c-red'>{newOrganizationDetailsRef.current.newBillTo.address1 && newOrganizationDetailsRef.current.newBillTo.address1}</dd>
                                    <dt></dt>
                                    <dd className='c-red'>{newOrganizationDetailsRef.current.newBillTo.address2 && newOrganizationDetailsRef.current.newBillTo.address2}</dd>
                                    <dt></dt>
                                    <dd className='c-red'>{newOrganizationDetailsRef.current.newBillTo.city && newOrganizationDetailsRef.current.newBillTo.city}{newOrganizationDetailsRef.current.newBillTo.state && ' '+newOrganizationDetailsRef.current.newBillTo.state} {newOrganizationDetailsRef.current.newBillTo.postalCode && ' '+newOrganizationDetailsRef.current.newBillTo.postalCode}</dd>
                                    <dt className='c-red'>NEW Cust Type:</dt>
                                    <dd className='c-red'>{newOrganizationDetailsRef.current.newCustType && newOrganizationDetailsRef.current.newCustType}</dd>
                                    <dt></dt>
                                    <dd></dd>
                                    <dd>
                                        <input className="btn btn-primary mb-2 me-1" type="button" onClick={addOrganizationToUser} value="Save Changes"></input>
                                        <input className="btn btn-primary mb-2" type="button" onClick={cancelAddOrganizationToUser} value="Cancel"></input>
                                    </dd>
                                </>
                            }  
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )

}